var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContrasena(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0 0 L 55 0.5 Q 41.3 3.8 34 13.5 Q 28 20.5 26 31.5 L 26 52 Q 19.9 52.3 17 56.5 L 15 60.5 L 15 120.5 L 18 126 L 22 127.5 L 0 128 L 0 0 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 73.5 0 L 128 0 L 128 128 L 106 127.5 L 110 126 L 113 120.5 L 113 60.5 L 108.5 54 L 102 52 L 102 31.5 L 101 27.5 Q 97.4 14.1 87.5 7 Q 82.4 2.1 73.5 1 L 73.5 0 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 59.5 8 L 68.5 8 L 75.5 10 L 89 21.5 L 93 30.5 L 94 52 L 87 52 L 87 32.5 Q 84.5 24 78.5 19 Q 72.2 12.8 57.5 15 Q 50.1 17.1 46 22.5 L 41 32.5 L 41 52 L 34 52 L 34 38.5 Q 36.8 36.8 35 30.5 L 39 21.5 L 47.5 13 L 59.5 8 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 61.5 23 Q 72.4 22.6 76 29.5 Q 80.8 38 79 52 L 49 52 L 49 38.5 L 52 29.5 L 56.5 25 L 61.5 23 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 25.5 61 L 102.5 61 L 105 63.5 L 105 117.5 L 102.5 120 L 25.5 120 L 23 117.5 L 23 63.5 L 25.5 61 Z M 62 67 L 55 70 L 49 78 Q 47 90 53 94 L 49 106 Q 47 111 51 113 L 78 113 L 79 112 L 79 106 L 75 94 L 79 88 Q 81 78 77 74 Q 73 67 62 67 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 61.5 76 L 66.5 76 L 71 80.5 L 71 84.5 L 66 90.5 L 66 93.5 L 69 105 L 59 105 L 59 101.5 L 62 90.5 Q 56.8 88.2 57 80.5 L 61.5 76 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 55.5 0 L 60 0.5 L 52.5 2 L 52.5 1 L 55.5 0 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 68.5 0 L 76 1.5 L 73.5 2 L 68.5 1 L 68.5 0 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 49.5 2 L 51 2.5 Q 41 6 35 13.5 L 29.5 23 L 29 21.5 Q 33.3 12.8 40.5 7 L 49.5 2 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 77.5 2 Q 88.1 5.4 94 13.5 L 99 22.5 L 98 22.5 Q 94.9 14.1 88.5 9 L 77.5 3 L 77.5 2 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 60.5 7 L 68 7.5 L 60.5 8 L 60.5 7 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 55.5 8 L 59 8.5 L 53.5 10 L 53.5 9 L 55.5 8 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 69.5 8 L 72 8.5 L 69.5 9 L 69.5 8 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 76.5 10 L 87 17.5 L 92 26.5 L 91 26.5 Q 88.3 17.2 80.5 13 Q 75.8 12.2 76.5 10 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 49.5 11 L 48.5 13 L 39 21.5 L 36.5 27 L 36 25.5 L 44.5 14 L 49.5 11 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 57.5 15 L 61 15.5 L 54.5 17 L 48 21 L 42 32.5 L 42 53 L 34 52.5 L 41 52 L 41 32.5 Q 43.5 24 49.5 19 L 57.5 15 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 67.5 15 Q 77.6 15.9 82 22.5 L 87 32.5 L 87 52 L 94 52.5 L 86 53 L 86 32.5 L 80 21 L 73.5 17 L 67.5 16 L 67.5 15 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 61.5 22 Q 73.3 21.7 77 29.5 Q 79.7 31.8 79 37.5 L 78 37.5 Q 77.6 28.4 71.5 25 Q 68.2 22.3 61.5 23 Q 55 24.5 52 29.5 L 49.5 38 L 49 33.5 L 56.5 24 L 61.5 22 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 27.5 27 L 28 29.5 L 27 29.5 L 27.5 27 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 100.5 27 L 101 29.5 L 100 29.5 L 100.5 27 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 26.5 31 L 27 53 L 24 52.5 L 26 52 L 26.5 31 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 34.5 31 L 35 37.5 L 34 37.5 L 34.5 31 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 93.5 31 L 94 37.5 L 93 37.5 L 93.5 31 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 101.5 31 L 102 52 L 104 52.5 L 101 53 L 101.5 31 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 49.5 52 L 79 52.5 L 49.5 53 L 49.5 52 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 21.5 53 L 23 53.5 L 18 56 L 16.5 59 L 17 57.5 L 19.5 54 L 21.5 53 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 105.5 53 L 111 56.5 L 112 58.5 L 110 57.5 Q 110.8 55.3 108.5 56 L 105.5 53 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 15.5 60 L 16 63.5 L 15 63.5 L 15.5 60 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 25.5 60 L 102.5 60 L 105 62.5 L 102.5 61 L 25.5 61 L 23.5 63 L 25.5 60 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 112.5 60 L 113 63.5 L 112 63.5 L 112.5 60 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 61.5 67 L 67 67.5 L 61.5 68 L 61.5 67 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 58.5 68 L 60 68.5 L 53 72.5 L 49.5 80 L 49 77.5 L 54.5 70 L 58.5 68 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 68.5 68 Q 74.3 69.3 77 73.5 L 79 79.5 L 78 79.5 Q 77.3 73.7 73.5 71 L 68.5 69 L 68.5 68 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 61.5 75 L 66.5 75 L 70 77 L 71 79.5 L 66.5 76 Q 58.7 74.7 57.5 80 L 58 78.5 Q 57.3 76.3 59.5 77 L 61.5 75 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 56.5 81 Q 57.1 87.9 62 90.5 L 62 93.5 L 60.5 97 L 60 94.5 L 61 90.5 L 56 84.5 L 56.5 81 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 71.5 81 L 72 83.5 L 71 83.5 L 71.5 81 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 49.5 85 L 50 87.5 L 49 87.5 L 49.5 85 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 70.5 85 L 71 86.5 L 67 90.5 L 67 93.5 L 68 96.5 L 67 96.5 L 66 90.5 L 70.5 85 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 78.5 85 L 79 87.5 L 78 87.5 L 78.5 85 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 50.5 89 L 53 92.5 L 50 90.5 L 50.5 89 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 77.5 89 L 78 90.5 L 75 92.5 L 77.5 89 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 52.5 94 L 53 96.5 L 52 96.5 L 52.5 94 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 75.5 94 L 78 103.5 L 77 103.5 L 75.5 94 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 51.5 98 L 52 100.5 L 50.5 104 L 50 101.5 L 51.5 98 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 59.5 98 L 60 100.5 L 59 100.5 L 59.5 98 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 68.5 98 L 69 100.5 L 68 100.5 L 68.5 98 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 58.5 102 L 59 105 L 68.5 105 L 69 102.5 L 70 102.5 L 69.5 106 L 58 106 L 58.5 102 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 49.5 105 L 50 107.5 L 49 107.5 L 49.5 105 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 78.5 105 L 79 107.5 L 78 107.5 L 78.5 105 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 49.5 111 L 50.5 113 L 49.5 111 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 78.5 111 L 77.5 113 L 78.5 111 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 15.5 117 Q 16.1 123.9 21 126.5 L 19.5 126 Q 17.3 126.8 18 124.5 Q 13.7 122.4 15.5 117 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 112.5 117 L 113 120.5 L 110 126 L 107.5 127 L 111 122.5 L 112.5 117 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.4823529411764706,
    d: "M 23.5 118 L 25.5 120 L 102.5 120 L 105 118.5 L 102.5 121 L 25.5 121 L 23.5 118 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 60.5 0 L 68 0.5 L 60.5 1 L 60.5 0 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 43.5 6 L 42.5 8 L 43.5 6 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 84.5 6 L 85.5 8 L 84.5 6 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 39.5 9 L 35.5 14 L 39.5 9 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 88.5 9 L 92.5 14 L 88.5 9 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 46.5 12 L 45.5 14 L 46.5 12 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 81.5 12 L 82.5 14 L 81.5 12 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 34.5 15 L 33.5 17 L 34.5 15 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 61.5 15 L 67 15.5 L 61.5 16 L 61.5 15 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 93.5 15 L 94.5 17 L 93.5 15 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 40.5 18 L 39.5 20 L 40.5 18 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 52.5 18 L 51.5 20 L 52.5 18 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 75.5 18 L 76.5 20 L 75.5 18 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 87.5 18 L 88.5 20 L 87.5 18 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 55.5 24 L 51.5 29 L 55.5 24 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 72.5 24 L 76.5 29 L 72.5 24 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 24.5 60 L 23 62.5 L 22.5 118 L 22 62.5 L 24.5 60 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 103.5 60 L 106 62.5 L 106 117.5 L 105 117.5 L 105 62.5 L 103.5 60 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 15.5 64 L 16 116.5 L 15 116.5 L 15.5 64 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 112.5 64 L 113 116.5 L 112 116.5 L 112.5 64 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 54.5 71 L 53.5 73 L 54.5 71 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 73.5 71 L 74.5 73 L 73.5 71 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 60.5 75 L 59.5 77 L 60.5 75 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 67.5 75 L 68.5 77 L 67.5 75 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 49.5 80 L 50 84.5 L 49 84.5 L 49.5 80 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 78.5 80 L 79 84.5 L 78 84.5 L 78.5 80 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 57.5 87 L 60.5 91 L 57.5 87 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 70.5 87 L 67.5 91 L 70.5 87 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 51.5 90 Q 54.5 90.5 54 94.5 L 53 94.5 L 51.5 90 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 76.5 90 L 75 92.5 L 74.5 95 L 74 92.5 L 76.5 90 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 49.5 108 L 51.5 112 L 53 112.5 L 51.5 113 Q 47.8 111.8 49.5 108 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 78.5 108 L 79 110.5 L 75.5 113 L 75.5 112 L 78 110.5 L 78.5 108 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 23.5 119 L 24.5 121 L 23.5 119 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 104.5 119 L 103.5 121 L 104.5 119 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 20.5 125 L 21.5 127 L 20.5 125 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 107.5 125 L 106.5 127 L 107.5 125 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 24.5 127 L 27 127.5 L 24.5 128 L 24.5 127 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 101.5 127 L 104 127.5 L 101.5 128 L 101.5 127 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 1 Q 68 -0.5 75.5 2 Q 86.5 6 93 14.5 L 100 27.5 L 101 32.5 L 101 53 Q 107.8 53.5 111 58.5 L 112 60.5 L 112 119.5 L 108.5 125 L 100.5 128 L 27.5 128 L 22.5 127 L 18 123.5 L 16 119.5 L 16 60.5 L 20.5 55 L 27 53 L 27 32.5 L 28 27.5 Q 32 15 41.5 8 L 56.5 1 Z M 59 7 L 47 12 Q 37 18 34 31 L 34 53 L 42 53 L 42 34 L 46 25 Q 50 19 59 16 Q 72 14 78 20 Q 84 25 86 34 L 86 53 L 94 53 L 94 31 L 89 20 Q 84 12 74 8 L 59 7 Z M 61 22 L 56 24 L 49 33 L 49 53 L 79 53 L 79 33 L 77 29 Q 73 21 61 22 Z M 25 60 L 22 63 L 22 118 L 23 120 L 25 121 L 104 121 L 106 118 L 106 63 L 104 60 L 25 60 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 68 Q 72.6 67.9 76 74.5 Q 79.5 78.5 78 87.5 L 74 92.5 L 74 94.5 L 76 98.5 L 78 110.5 L 74.5 113 L 53.5 113 L 50 110.5 L 50 106.5 L 54 92.5 Q 48 89.5 50 78.5 L 55.5 71 L 62.5 68 Z M 61 75 L 56 81 Q 55 90 61 92 L 57 105 L 58 106 L 71 106 L 67 93 L 72 86 L 71 79 Q 69 73 61 75 Z "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContrasena);
export default __webpack_public_path__ + "static/media/contrasena.a8a62dbebbd97a20ad93de9dba7a7bb2.svg";
export { ForwardRef as ReactComponent };